import { scaleLinear } from 'd3-scale'

export default {
  resample (data, samplesPerPixel) {
    const sampleStart = 0
    const sampleEnd = data.length
    const samples = []

    let sampleIndex = 0

    const scale = scaleLinear()
      .domain([0, data.length])
      .rangeRound([0, data.length / samplesPerPixel])

    for (sampleIndex; sampleIndex < data.length; sampleIndex += 1) {
      samples[scale(sampleIndex)] = data[sampleIndex]
    }

    return samples.slice(sampleStart, sampleEnd)
  }
}
